export enum COUPON_STATUS {
  UNUSED = "UNUSED",
  USED = "USED",
  EXPIRED = "EXPIRED",
}

export interface CouponProps {
  code: string;
  desc: string;
  status: COUPON_STATUS;
  package_id_list: number[];
  expired_at: number;
}
